import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=77e67c64"
import script from "./Atendimentos.vue?vue&type=script&lang=js"
export * from "./Atendimentos.vue?vue&type=script&lang=js"
import style0 from "./Atendimentos.vue?vue&type=style&index=0&id=77e67c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports